export default __webpack_public_path__ + "static/media/Highlights-Sphere_normal.05d69c64.png";